import type { AppIntegracion, IntegracionDTO, WrapperResponse } from '../../../model/kartera-api-model'
import APIInvoke from '../../../utils/APIInvoke'

export { errorMessage } from '../../customers/common/customer-common'

export const INTEGRATIONS_PATH = '/configuracion/integraciones'
export const INTEGRATIONS_BACK_PATH = '/configuracion'
export const TODOIST_PATH = `${INTEGRATIONS_PATH}/todoist`
export const TODOIST_TOKEN_PARAM = 'token'
export const TODOIST_ICON = '/integrations/todoist/todoist-icon.png'
export const TODOIST_HELP_URL = 'https://appdalala.blogspot.com/2022/05/integracion-todoist.html'
export const TODOIST_REGISTER_URL = 'https://todoist.com/users/showregister'
export const MASKED_VALUE = '**********'

export const fetchIntegration = async (aplicacion: AppIntegracion): Promise<IntegracionDTO[]> => {
    const response: WrapperResponse<IntegracionDTO[]> | null = await (await APIInvoke.invokeGET(`/integraciones?aplicacion=${aplicacion.toUpperCase()}`)).json()
    if (!response?.ok) throw new Error(response?.message || 'Error al consultar los parámetros')
    return response.body || []
}

export const findParam = (items: IntegracionDTO[], parametro: string) => items.find((item) => item.parametro === parametro)
